module.exports = __webpack_public_path__ + "img/water03_selected.cfb8efdd.png";